import { BASE_URL_SETTING } from '../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'

const base = `${BASE_URL_SETTING}/ftp`

export const SETTINGS_FTP: Route = {
  path: base
}

export const SETTINGS_FTP_CREATE: Route = {
  path: `${base}/create`
}

export const SETTINGS_FTP_EDIT: Route = {
  path: `${base}/{id}`
}
